import { lazy } from 'react';

export const WelcomePage = lazy(() => import('./ui/Welcome'));
